jQuery(document).ready(function ($) {
    //Add "remove" function in IE
    if (!('remove' in Element.prototype)) {
        Element.prototype.remove = function () {
            if (this.parentNode) {
                this.parentNode.removeChild(this);
            }
        };
    }

    $('.bocss-icon__preview .bocss-icon__holder').each(function () {
        let $this = $(this);
        let iconTitle = $(this).find('.bocss-icon__title');

        //Set up the copy code click
        $this.click(function () {
            let inp = document.createElement('input');
            document.body.appendChild(inp);
            inp.value = iconTitle.text();
            inp.select();
            document.execCommand('copy', false);
            inp.remove();

            let snackbar = document.getElementById('snackbar');
            snackbar.className = 'show';

            //Hide 'Copied!' after 3 seconds
            setTimeout(function () {
                snackbar.className = snackbar.className.replace('show', '');
            }, 3000);
        });

        // Display only those icons belonging to the default icon set
        let iconSet = $(this).find('.bocss-icon').attr('data-icon-set');
        let defaultSet = $('#iconSelector').val();
        $this.toggle(iconSet.localeCompare(defaultSet) === 0);

        // Search and selector functionality
        $('#iconSearch, #iconSelector').on('keyup change', function () {
            let searchValue = $('#iconSearch').val().toLowerCase();
            let selectedSet = $('#iconSelector').val();

            $($this).filter(function () {
                let matchesSearch = $(this).text().toLowerCase().indexOf(searchValue) > -1;
                let matchesFilter = iconSet.localeCompare(selectedSet) === 0;

                $(this).toggle(matchesSearch && matchesFilter);
            });
        });
    });

    // Added to avoid page jump when searching
    var minHeight = $('.bocss-icon__preview').height();
    $('#preview_container').css('min-height', minHeight);
});
